export const CityService = (http) => ({
	async searchByName(name) {
		const response = await http.get('/api/Cities', {
			params: { page: 1, pageSize: 1000, name },
			headers: { 'api-version': '0.1' },
		});
		return response.data.entities;
	},

	async assignContainer(cityId, containerId) {
		const response = await http.put(
			`/api/Cities/${cityId}/containers/${containerId}`,
			{
				headers: { 'api-version': '0.1' },
			},
		);

		return response.data;
	},
});
